module.exports = __webpack_public_path__ + "static/media/11.4d54257c.jpg";